<template>
    <el-dialog width="440px" v-model="dialogVisible" :close-on-click-modal="true" :before-close="cancledialog" draggable
        :show-close="false">
        <el-form :model="form" label-position="right" v-loading="loading">
            <el-row :gutter="10" style="margin-bottom: 20px;">
                <el-col :span="24">
                    <div :class="form.positionSide === constants.SHORT ? 'title red' : 'title green'">{{ title }}</div>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-bottom: 20px;">
                <el-col :span="24">
                    <el-alert :title="'开仓均价  ' + form.entryPrice1" type="warning" :closable="false" />
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="止盈" label-width="70px">
                        <el-input class="price" v-model="form.tpNewTriggerPx">
                            <template #append>
                                <el-select v-model="form.tpWorkingType" placeholder="请选择" style="width:80px">
                                    <el-option label="标记" :value="constants.MARK_PRICE"></el-option>
                                    <el-option label="最新" :value="constants.CONTRACT_PRICE"></el-option>
                                </el-select>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-button v-if="form.tpOrderId || form.tpAlgoId" icon="Delete" text type="primary"
                        :loading="tploading" @click="cancleTP()" />
                </el-col>
            </el-row>
            <div class="note">
                当最新价格到达<span>{{ form.tpNewTriggerPx }}</span>时，将会触发市价止盈委托平仓当前仓位。<br>
                预计盈亏为&nbsp;<span v-html="expectedTakeProfit"></span>&nbsp;USDT
            </div>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="止损" label-width="70px">
                        <el-input class="price" v-model="form.slNewTriggerPx">
                            <template #append>
                                <el-select v-model="form.slWorkingType" placeholder="请选择" style="width:80px">
                                    <el-option label="标记" :value="constants.MARK_PRICE"></el-option>
                                    <el-option label="最新" :value="constants.CONTRACT_PRICE"></el-option>
                                </el-select>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-button v-if="form.slOrderId || form.slAlgoId" icon="Delete" text type="primary"
                        :loading="slloading" @click="cancleSL()" />
                </el-col>
            </el-row>
            <div class="note">
                当最新价格到达<span>{{ form.slNewTriggerPx }}</span>时，将会触发市价止损委托平仓当前仓位。<br>
                预计盈亏为&nbsp;<span v-html="expectedStopMarket"></span>&nbsp;USDT
            </div>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="info" plain @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" plain @click="submit()" :disabled="loading">保 存</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<style scoped>
.title {
    font-size: 18px;
    font-weight: bold;
}

.green {
    color: #67c23a;
}

.red {
    color: #f56c6c;
}

.entryPrice {
    border-radius: 5px;
    color: #555657;
    background: #cabe75;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 14px;
}

.note {
    border-radius: 5px;
    color: #909399;
    background: #202121;
    padding: 10px;
    margin-bottom: 20px;
    font-size: 12px;
}
</style>

<script setup>
import { ref, toRaw, computed } from 'vue'
import { ElMessage } from 'element-plus'
import Decimal from 'decimal.js'
import * as constants from '@/utils/binanceConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import Database from '@/service/database'

const systemStore = useSystemStore()
const logStore = useLogStore()
const dialogVisible = ref(false)
const loading = ref(false)
const tploading = ref(false)
const slloading = ref(false)
const title = ref("")
const form = ref({
    entryPrice: "",
})

const expectedTakeProfit = computed(() => {
    if (!form.value.tpNewTriggerPx) return "--"
    let diff = 0
    if (form.value.positionSide === constants.LONG) {
        diff = parseFloat(form.value.tpNewTriggerPx) - parseFloat(form.value.entryPrice)
    } else {
        diff = parseFloat(form.value.entryPrice) - parseFloat(form.value.tpNewTriggerPx)
    }
    diff = diff * Math.abs(parseFloat(form.value.positionAmt))
    diff = new Decimal(diff).toDecimalPlaces(2, Decimal.ROUND_FLOOR).toNumber()
    return diff > 0 ? `<span style="color:#67c23a">+${diff}</span>` : `<span style="color:#ff707e">${diff}</span>`
})

const expectedStopMarket = computed(() => {
    if (!form.value.slNewTriggerPx) return "--"
    let diff = 0
    if (form.value.positionSide === constants.LONG) {
        diff = parseFloat(form.value.slNewTriggerPx) - parseFloat(form.value.entryPrice)
    } else {
        diff = parseFloat(form.value.entryPrice) - parseFloat(form.value.slNewTriggerPx)
    }
    diff = diff * Math.abs(parseFloat(form.value.positionAmt))
    diff = new Decimal(diff).toDecimalPlaces(2, Decimal.ROUND_FLOOR).toNumber()
    return diff > 0 ? `<span style="color:#67c23a">+${diff}</span>` : `<span style="color:#ff707e">${diff}</span>`
})

const init = async (data) => {
    dialogVisible.value = true

    let workingTypes = await Database.select('WorkingType')
    let tpWorkingType = workingTypes.find(x => x.Name == 'TP' && x.Platform == 'BINANCE')?.Type || constants.CONTRACT_PRICE
    let slWorkingType = workingTypes.find(x => x.Name == 'SL' && x.Platform == 'BINANCE')?.Type || constants.CONTRACT_PRICE

    //标题
    title.value = `${data.symbol} ${(data.positionSide === constants.LONG ? '多' : '空')} ×${data.leverage}`

    //获取止盈止损设置
    form.value = data
    form.value.tpOrderId = data.tpOrderId || ""
    form.value.tpAlgoId = data.tpAlgoId || ""
    form.value.tpTriggerPx = data.tpTriggerPx || ""
    form.value.tpNewTriggerPx = data.tpTriggerPx || ""
    form.value.tpWorkingType = data.tpWorkingType || tpWorkingType
    form.value.slOrderId = data.slOrderId || ""
    form.value.slAlgoId = data.slAlgoId || ""
    form.value.slTriggerPx = data.slTriggerPx || ""
    form.value.slNewTriggerPx = data.slTriggerPx || ""
    form.value.slWorkingType = data.slWorkingType || slWorkingType
}

const cancledialog = () => {
    dialogVisible.value = false
    form.value = { entryPrice: "" }
}

const submit = async () => {
    if (!form.value.tpNewTriggerPx && !form.value.slNewTriggerPx) {
        loading.value = false
        return
    }

    try {
        loading.value = true
        
        const cancelOrderPromises = []
        const cancelAlgoPromises = []
        const newOrders = []

        // 止盈有改动
        if (form.value.tpNewTriggerPx != form.value.tpTriggerPx) {
            // 收集需要撤销的订单
            if (form.value.tpOrderId) {
                cancelOrderPromises.push(
                    systemStore.privateClient.cancelOrder(form.value.symbol, form.value.tpOrderId)
                )
            }
            if (form.value.tpAlgoId) {
                cancelAlgoPromises.push(
                    systemStore.privateClient.cancelAlgoOrder(form.value.tpAlgoId)
                )
            }

            // 止盈有添加
            if (form.value.tpNewTriggerPx) {
                newOrders.push({
                    symbol: form.value.symbol,
                    side: form.value.positionSide === constants.LONG ? constants.SELL : constants.BUY,
                    positionSide: form.value.positionSide,
                    algoType: 'CONDITIONAL',
                    type: constants.TAKE_PROFIT_MARKET,
                    closePosition: true,
                    triggerPrice: form.value.tpNewTriggerPx,
                    workingType: form.value.tpWorkingType,
                })
            }
        }

        // 止损有改动
        if (form.value.slNewTriggerPx != form.value.slTriggerPx) {
            // 收集需要撤销的订单
            if (form.value.slOrderId) {
                cancelOrderPromises.push(
                    systemStore.privateClient.cancelOrder(form.value.symbol, form.value.slOrderId)
                )
            }
            if (form.value.slAlgoId) {
                cancelAlgoPromises.push(
                    systemStore.privateClient.cancelAlgoOrder(form.value.slAlgoId)
                )
            }

            // 止损有添加
            if (form.value.slNewTriggerPx) {
                newOrders.push({
                    symbol: form.value.symbol,
                    side: form.value.positionSide === constants.LONG ? constants.SELL : constants.BUY,
                    positionSide: form.value.positionSide,
                    algoType: 'CONDITIONAL',
                    type: constants.STOP_MARKET,
                    closePosition: true,
                    triggerPrice: form.value.slNewTriggerPx,
                    workingType: form.value.slWorkingType,
                })
            }
        }

        // 没有需要操作的就返回
        if (!cancelOrderPromises.length && !cancelAlgoPromises.length && !newOrders.length) {
            loading.value = false
            return
        }

        // 并发取消所有订单
        try {
            await Promise.all([...cancelOrderPromises, ...cancelAlgoPromises])
        } catch (cancelError) {
            // 忽略"订单不存在"之类的错误，继续执行
            console.warn('取消订单时出错:', cancelError)
        }

        // 等待100ms确保服务端状态同步
        await new Promise(resolve => setTimeout(resolve, 100))

        // 创建新订单（如果有）
        if (newOrders.length) {
            const createPromises = newOrders.map(order => 
                systemStore.privateClient.algoOrder(order).catch(err => {
                    // 如果是冲突错误，等待更长时间后重试
                    if (err.code === -4165) {
                        return new Promise((resolve, reject) => {
                            setTimeout(() => {
                                systemStore.privateClient.algoOrder(order)
                                    .then(resolve)
                                    .catch(reject)
                            }, 500)
                        })
                    }
                    throw err
                })
            )
            
            await Promise.all(createPromises)
        }
        
        loading.value = false
        dialogVisible.value = false
        ElMessage.success('保存成功')
        
    } catch (error) {
        loading.value = false
        ElMessage.error('保存失败: ' + (error.message || error))
        logStore.addLog({
            title: '保存止盈止损失败',
            level: 'error',
            message: error
        })
    }
}

const cancleTP = async () => {
    if (!form.value.tpOrderId && !form.value.tpAlgoId) return
    tploading.value = true
    try {
        if (form.value.tpOrderId) {
            await systemStore.privateClient.cancelOrder(form.value.symbol, form.value.tpOrderId)
            form.value.tpOrderId = ""
        }
        if (form.value.tpAlgoId) {
            await systemStore.privateClient.cancelAlgoOrder(form.value.tpAlgoId)
            form.value.tpAlgoId = ""
        }

        form.value.tpTriggerPx = ""
        form.value.tpNewTriggerPx = ""
        tploading.value = false
        ElMessage.success('已撤销')
    } catch (error) {
        tploading.value = false
        ElMessage.error('撤销失败' + error)
        logStore.addLog({
            title: '撤销止盈失败',
            level: 'error',
            message: error
        })
    }
}

const cancleSL = async () => {
    if (!form.value.slOrderId && !form.value.slAlgoId) return
    slloading.value = true
    try {

        if (form.value.slOrderId) {
            await systemStore.privateClient.cancelOrder(form.value.symbol, form.value.slOrderId)
            form.value.slOrderId = ""
        }

        if (form.value.slAlgoId) {
            await systemStore.privateClient.cancelAlgoOrder(form.value.slAlgoId)
            form.value.slAlgoId = ""
        }

        form.value.slTriggerPx = ""
        form.value.slNewTriggerPx = ""

        slloading.value = false
        ElMessage.success('已撤销')
    } catch (error) {
        slloading.value = false
        ElMessage.error('撤销失败' + error)
        logStore.addLog({
            title: '撤销止损失败',
            level: 'error',
            message: error
        })
    }
}

defineExpose({ init })
</script>